<template>
  <el-input class="appraisal-number" type="number" :value="value == null ? '' : value" :label="label" :aria-label="label" :disabled="disabled" :size="size" :min="min" :max="max" :step="precision === 0 ? 1 : 0.01" placeholder="待填写" @input="update" />
</template>

<script>
export default {
  name: 'AppraisalNumber',
  props: { value: Number, label: String, disabled: Boolean, size: String, min: Number, max: Number, precision: Number },
  methods: {
    update(raw) {
      const value = raw === '' ? undefined : Number(raw)
      if (value !== undefined && !Number.isFinite(value)) return
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
.appraisal-number { width:150px; }
.appraisal-number /deep/ input { font-variant-numeric:tabular-nums; }
</style>
